import { Grid, Box } from '@mui/material';
import IncidentFeed from './IncidentFeed';
import AcademicYearStanding from './AcademicYearStanding';
import MonthStanding from './MonthStanding';

const DisciplineStats = ({ 
  stats, 
  incidents, 
  monthData,
}) => {
  return (
    <Box sx={{ borderRadius: 4 }}>
      <Grid container spacing={1.5}>
        
        <Grid item xs={12} md={8}>
          <IncidentFeed 
            incidents={incidents} 
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <AcademicYearStanding 
            totalPoints={stats.totalPoints} 
            merits={stats.merits} 
            demerits={stats.demerits} 
          />
          <MonthStanding months={monthData} />
        </Grid>

      </Grid>
    </Box>
  );
};

export default DisciplineStats;